import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Role } from '../../shared/models/role';
import { User } from '../../users/models/user';
import * as fromAuth from './../../store/';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  currentRole: Role;
  userLoaded: boolean;
  user: User;
  constructor(
    private store: Store<fromAuth.AuthState>,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

    return this.store.pipe(
      select(fromAuth.selectSessionFeature),
      map((auth) => {
        const hasPermission = auth.currentRole && auth.currentRole.code;
        if (hasPermission) {
          return true;
        } else {
          const isAuthenticate = auth.isAuthentiate;
          if (isAuthenticate) {
            this.router.navigate(['/roles', { queryParams: { returnUrl: state.url } }]);
            return false;
          } else {
            this.router.navigate(['/login']);
            return false;
          }
        }
      }),
    );
  }

}
